module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-chalk-2-1645b4e5094d5dbf3ffbac496b2ec671.png";